export default "__VITE_ASSET__Dti0Wnjn__"